<template>
  <div class="row">
    <div class="col-md-12">
      <membership-chart :data="membershipProgress" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MembershipChart from '../elements/membership-chart'
import json2csv from '@/Plugins/json2csv'
export default {
  name: 'analyze-membership',
  components: {
    MembershipChart,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  async mounted() {
    await this.reload()
  },
  computed: {
    ...mapGetters('reporting', ['analysis', 'membershipProgress']),
    ...mapGetters('organizations', ['examineOrganization']),
  },
  methods: {
    ...mapActions('global', ['setReload']),
    ...mapActions('reporting', ['getMembershipProgress', 'resetData']),
    reload() {
      this.setReload(true)
      this.isLoading = true
      this.resetData({ name: 'membership' })
      this.getMembershipProgress({
        orgId: this.examineOrganization.id,
        challengeId: this.analysis.challengeId,
        startDate: this.analysis.startDate,
        endDate: this.analysis.endDate,
      })
      this.setReload(false)
      this.isLoading = false
    },
    download() {
      var filename = `membership_results_${new Date().toLocaleDateString()}`
      json2csv.exportCSVFile(null, this.membershipProgress, filename)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow: auto;
  max-height: 65vh;
  width: 100%;
}
</style>
